import { Dictionary } from 'vue-router/types/router';
import { TranslateResult } from 'vue-i18n';

export class MeetingPath {
  name:string|TranslateResult;
  path?:string;
  active?:boolean;
  submenu?:Array<MeetingPath>;
  router?:boolean;
  id?:number;
  params?: Dictionary<string>
  noTranslate?: boolean;
  disabled?: boolean;
  function?: (params:any) => void;
  isAlerted: boolean;
  alertComponent: string;
  route?: string;
  isInternal ?: boolean;

  constructor(data:any){
    this.name = data.name;
    this.path = data.path ? data.path : '#';
    this.active = data.active ? data.active : false;
    this.submenu = data.submenu ? data.submenu : [];
    this.router = data.router ? data.router : false;
    this.route = data.route || '';
    this.id = data.id ? data.id : 0;
    this.params = data.params ? data.params : {};
    this.noTranslate = data.noTranslate ? data.noTranslate : false;
    this.disabled = data.disabled ? data.disabled : false;
    this.function = data.function ? data.function : null;
    this.isAlerted = data.isAlerted || false;
    this.alertComponent = data.alertComponent || '';
    this.isInternal = data.isInternal || false;
  }
}